import { Tempo } from "../models/tempo";

export abstract class TimeFormatter {

  static toLocaleString(tempo: Tempo): string {
    if (tempo == null) return '';
    return new Date(tempo.ano, tempo.mes - 1, tempo.dia, tempo.hora, tempo.minuto)
        .toLocaleString();
  }

  static getNow(): String[] {
    let date = new Date();

    let dia = date.getDate().toString().padStart(2, '0');
    let mes = (date.getMonth() + 1).toString().padStart(2, '0');
    let ano = date.getFullYear().toString().padStart(2, '0');
    let hora = date.getHours().toString().padStart(2, '0');
    let minutos = date.getMinutes().toString().padStart(2, '0');

    let r = [dia, mes, ano, hora, minutos]

    return r
  }

  static getMonthAgo(): String[]{
    let date = new Date();

    //2592000000 → em milisegundos
    date.setTime(date.getTime() - 2592000000)

    let dia = date.getDate().toString().padStart(2, '0');
    let mes = (date.getMonth() + 1).toString().padStart(2, '0');
    let ano = date.getFullYear().toString().padStart(2, '0');
    let hora = date.getHours().toString().padStart(2, '0');
    let minutos = date.getMinutes().toString().padStart(2, '0');
    
    let r = [dia, mes, ano, hora, minutos]

    return r
  }

}